// Centralised order edit permission helper.
//
// Use canEditOrder(user, order) wherever a UI element grants edit rights
// scoped to a specific order. Contremaîtres and Commerciaux can only edit
// the orders they are personally involved in. Admin / Pilote / Assistante
// de gestion keep their global edit rights. Chef d'agence is scoped to
// their assigned zones.

export function canEditOrder(user, order) {
  if (!user) return false;

  if (user.role === "Admin" || user.role === "Pilote") return true;
  if (user.role === "Assistante de gestion") return true;
  if (user.role === "Direction") return false;

  if (user.role === "Chef d'agence") {
    return Boolean(
      order &&
        Array.isArray(user.user_areas) &&
        user.user_areas.includes(order.area)
    );
  }

  if (!order) return false;

  const isForeman = user.user_id === order.foreman_id;
  const isCommercial =
    user.user_id === order.salesman_id ||
    user.user_id === order.responsible_business_id;

  if (user.role === "Contremaître") return isForeman || isCommercial;
  if (user.role === "Commercial") return isCommercial || isForeman;

  return false;
}
